import JSZip from 'jszip'

// Nombre válido como archivo: sin barras (crearían subcarpetas en el zip) ni caracteres prohibidos
export const nombreArchivo = texto => String(texto).replace(/[\\/:*?"<>|]/g, '-').trim()

// archivos: [{ nombre: 'x.pdf', contenido: Blob }] → descarga un único .zip
export async function descargarZip(nombreZip, archivos) {
  const zip = new JSZip()
  const usados = {}
  archivos.forEach(({ nombre, contenido }) => {
    // Evitar que dos archivos con el mismo nombre se pisen dentro del zip
    usados[nombre] = (usados[nombre] || 0) + 1
    const final = usados[nombre] > 1 ? nombre.replace(/(\.[^.]+)?$/, ` (${usados[nombre]})$1`) : nombre
    zip.file(final, contenido)
  })

  const blob = await zip.generateAsync({ type: 'blob' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = nombreZip
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  setTimeout(() => URL.revokeObjectURL(url), 60000)
}
